import { Component, Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IUserProfile } from '../login/login';

@Injectable()
export class AuthService {

    constructor(private http: HttpClient
    ) { }

    // public getToken(): Observable<string> {
    //     return this.adalService.acquireToken('http://schemas.microsoft.com/identity/claims/objectidentifier').map(
    //         token => token.toString()
    //     );
    // }

    public getAuthentication(): Observable<IUserProfile> {
        const url = '/api/Authentication/ValidateUser';
        return this.http.get<any>(url)
    }

    // private handleError(error: Response) {
    //     console.error(error);
    //     return Observable.throw(error.json().error || 'Server error');
    // }
}
